// extracted by mini-css-extract-plugin
module.exports = {"cart-items":"Cart_cart-items__1NYJe","total":"Cart_total__30j6k","actions":"Cart_actions__d9EJG","button--alt":"Cart_button--alt__NloaK","button":"Cart_button__11cky"};